import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CountryCode, getCountryCallingCode } from 'libphonenumber-js';
import { CountryListService } from '@gelato-api-ui/sdk/src/lib/shared/country-selector/country-list.service';
import { CountryOption, CountryWithDialingCode } from './types/country-selector';

@Injectable({ providedIn: 'root' })
export class CountryListWithDialingCodesService {
  constructor(private readonly countryListService: CountryListService) {}

  getCountriesWithDialingCodes(): Observable<CountryWithDialingCode[]> {
    const notSupportedCountryCodes = ['GS', 'IC', 'TF', 'PN'];

    return this.countryListService.getOptions().pipe(
      map((options: CountryOption[]) =>
        options
          .filter(
            (loopOption: CountryOption): boolean =>
              Boolean(loopOption) && !notSupportedCountryCodes.includes(loopOption.id),
          )
          .map(
            (loopOption: CountryOption): CountryWithDialingCode => ({
              code: loopOption.id,
              name: loopOption.name,
              dialingCode: `+${getCountryCallingCode(loopOption.id as CountryCode)}`,
            }),
          ),
      ),
    );
  }
}
